<template>
    <a
        class="base-card"
        :href="post.link"
        :target="linkTarget"
        :class="{ 'base-card--show': visible }"
    >
        <figure class="base-card__figure">
            <img
                v-if="imageSrc"
                class="base-card__image"
                :src="imageSrc"
                :srcset="imageSrcSet"
                :sizes="sizes"
            />
            <!-- :src="imageSrc" -->
            <div
                class="label-reference"
                :data-image-reference="imageReference"
            />
            <div
                v-if="label"
                class="base-card__label-type"
            >
                {{ label }}
            </div>
        </figure>

        <div
            v-if="post.showCategories"
            class="base-card__date base-card__category"
        >
            <span v-if="category">{{ category }}</span>
            <span v-else>&nbsp;</span>
        </div>

        <h2
            v-if="post.title.rendered"
            class="base-card__title"
            v-html="post.title.rendered"
        />

        <div
            v-if="date"
            class="base-card__date"
        >
            {{ date }}
        </div>

        <div
            v-if="post.excerpt.rendered"
            class="base-card__copy"
            v-html="post.excerpt.rendered"
        />
    </a>
</template>

<script>
import BaseCard from './BaseCard.vue'
import { getSizesStringByColumns } from '@bahn-wordpress/common/src/js/admin/utils/source-set'

export default {
    name: 'CardPost',
    extends: BaseCard,

    props: {
        post: {
            type: Object,
            default(){
                return {}
            },
        },
        label: {
            type: String,
            default: '',
        },
    },
    data(){
        return {
            linkTarget: '_self',
        }
    },

    computed: {
        image(){
            return this.post.dbec_featured_media || {}
        },
        imageSrc(){
            return this.image.source_url
        },
        imageSrcSet(){
            return this.image.source_set
        },
        imageReference(){
            return this.image.caption
        },
        date(){
            if (this.post.date) {
                const english = document.documentElement.lang.startsWith('en')
                const date = new Date(this.post.date)
                const day = this.addLeadingZero(date.getDate())
                const month = this.addLeadingZero(date.getMonth() + 1)
                const year = date.getFullYear()

                return english
                    ? `${month}-${day}-${year}`
                    : `${day}.${month}.${year}`
            }
            return null
        },
        sizes(){
            return getSizesStringByColumns({ small: 6, medium: 3, large: 2 })
        },
        category(){
            if (this.post.categoryNames && this.post.categoryNames.length > 0) {
                return this.post.categoryNames[0]
            }
            return null
        },
    },

    methods: {
        addLeadingZero(number){
            let numberAsString = String(number)
            if (numberAsString.length === 1) {
                numberAsString = `0${numberAsString}`
            }
            return numberAsString
        },
    },
}
</script>
